export default __webpack_public_path__ + "static/media/submit-button-on-blur.83b1dde5.png";